// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);
  display: flex;
  flex-direction: column;
}

.auth-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
}
.auth-topbar a { color: #93c5fd; font-weight: 600; text-decoration: none; }
.auth-topbar a:hover { color: var(--white); }
.auth-brand { color: var(--white); font-size: 1.1rem; font-weight: 700; }

.auth-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
}

.auth-card {
  background: var(--white);
  border-radius: var(--radius);
  padding: 48px 40px;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 25px 50px rgb(0 0 0 / .3);
}

.auth-card h1 {
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: -.02em;
  margin-bottom: 6px;
}

.auth-card .subtitle {
  color: var(--text-muted);
  font-size: .9rem;
  margin-bottom: 32px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.auth-footer {
  text-align: center;
  margin-top: 24px;
  font-size: .9rem;
  color: var(--text-muted);
}
.auth-footer a { font-weight: 600; }

@media (max-width: 500px) {
  .auth-card { padding: 32px 24px; }
  .form-row { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA,iBAAiB,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC1E,uBAAuB,mBAAmB,EAAE;AAC5C,cAAc,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAExE;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,aAAa,kBAAkB,EAAE;EACjC,YAAY,0BAA0B,EAAE;AAC1C","sourcesContent":[".auth-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);\n  display: flex;\n  flex-direction: column;\n}\n\n.auth-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 32px;\n}\n.auth-topbar a { color: #93c5fd; font-weight: 600; text-decoration: none; }\n.auth-topbar a:hover { color: var(--white); }\n.auth-brand { color: var(--white); font-size: 1.1rem; font-weight: 700; }\n\n.auth-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n}\n\n.auth-card {\n  background: var(--white);\n  border-radius: var(--radius);\n  padding: 48px 40px;\n  width: 100%;\n  max-width: 460px;\n  box-shadow: 0 25px 50px rgb(0 0 0 / .3);\n}\n\n.auth-card h1 {\n  font-size: 1.6rem;\n  font-weight: 800;\n  letter-spacing: -.02em;\n  margin-bottom: 6px;\n}\n\n.auth-card .subtitle {\n  color: var(--text-muted);\n  font-size: .9rem;\n  margin-bottom: 32px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.auth-footer {\n  text-align: center;\n  margin-top: 24px;\n  font-size: .9rem;\n  color: var(--text-muted);\n}\n.auth-footer a { font-weight: 600; }\n\n@media (max-width: 500px) {\n  .auth-card { padding: 32px 24px; }\n  .form-row { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
